import {
  Configuration,
  PopupRequest,
  PublicClientApplication,
} from "@azure/msal-browser";

const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID;
if (!clientId) {
  throw new Error("REACT_APP_ENTRA_CLIENT_ID is not defined in the environment variables.");
}

const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID;
if (!tenantId) {
  throw new Error("REACT_APP_ENTRA_TENANT_ID is not defined in the environment variables.");
}

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest: PopupRequest = {
  scopes: [],
  prompt: "login",
};

// export const apiRequest: PopupRequest = {
//   scopes: [process.env.REACT_APP_ENTRA_SSO_SCOPE! ],
// };

export async function getAccessToken(account: any) {
  if (!account) {
    console.error("No account found. Cannot acquire token.");
    return null;
  }

  try {

    const authResult = await msalInstance.acquireTokenSilent({
      scopes:[ process.env.REACT_APP_ENTRA_SSO_SCOPE! ],
      account,
    });
    
    return authResult.accessToken;
  } catch (error) {
    console.error("Failed to acquire token:", error);
    return null;
  }
}
